import { cn } from '../lib/cn'

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
}

export function Container({ className, ...props }: ContainerProps) {
  return (
    <div
      className={cn(
        'mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8',
        className
      )}
      {...props}
    />
  )
}
